import axios from 'axios'
import { showNotify } from 'vant';
import i18n from '@/lang/index'
import aesUtil from '@/utils/tokenUtil'
export default function $axios(options) {
  return new Promise((resolve, reject) => {
    const instance = axios.create({
      baseURL: import.meta.env.VITE_APP_BASE_API,
      timeout: options.timeout || 120000,
    })
    // request 拦截器
    instance.interceptors.request.use(
      async (config) => {
        const tokenData = aesUtil.generateAuthData(import.meta.env.VITE_APP_APP_NAME, import.meta.env.VITE_APP_APP_PASSWORD)
        if (tokenData.authHeader) {
          // let each request carry token
          // ['X-Token'] is a custom headers key
          // please modify it according to the actual situation
          config.headers['Authorization'] = tokenData.authHeader
          return config
        }
      },
      error => {
        // do something with request error
        return Promise.reject(new Error(error))
      }
    )
    // response interceptor
    instance.interceptors.response.use(
      response => {
        // 响应成功处理
        return httpResopnse(response, options)
      },
      err => {
        // 响应失败处理/网络错误，接口不存在
        return httpError(err, options)
      }
    )
    // 请求处理
    instance(options)
      .then(res => {
        resolve(res)
        return false
      })
      .catch(error => {
        reject(new Error(error))
      })
  })
}

// http 响应
const httpResopnse = async (response, options) => {
  const res = response.data
  // 如果返回code不是200，进行错误处理
  if ((res.code !== '200')) {
    if (!options.hideError) {
      setTimeout(() => {
        showNotify({ type: 'danger', message: res.message || res.error_description || 'Error' });
      })
    }
    return res
  } else {
    return res
  }
}

// http 报错
const httpError = async (err, options) =>{
  if (err?.response) {
    switch (err.response.status) {
      case 400:
        err.message = i18n.global.t('errorMsg.400')
        break

      case 401:
        err.message = i18n.global.t('errorMsg.401')
        break

      case 403:
        err.message = i18n.global.t('errorMsg.403')
        break

      case 404:
        // err.message = `请求地址出错: ${err.response.config.url}`
        err.message = i18n.global.t('errorMsg.404')
        break

      case 408:
        err.message = i18n.global.t('errorMsg.408')
        break

      case 500:
        err.message = i18n.global.t('errorMsg.500')
        break

      case 501:
        err.message = i18n.global.t('errorMsg.501')
        break

      case 502:
        err.message = i18n.global.t('errorMsg.502')
        break

      case 503:
        err.message = i18n.global.t('errorMsg.503')
        break

      case 504:
        err.message = i18n.global.t('errorMsg.504')
        break

      case 505:
        err.message = i18n.global.t('errorMsg.505')
        break
      default:
    }
  }
  // 超时
  if (err.code === 'ECONNABORTED' && err.message.indexOf('timeout') !== -1) {
    err.message = i18n.global.t('errorMsg.timeout')
  }
  showNotify({ type: 'danger', message: err.message});
  return Promise.reject(new Error(err) )
}

